import React from "react";
import { useQuery } from "@apollo/client";
import { GET_ORDER_MODERATION } from "../../api/graphql/moderation";
import ModerationActions from "./ModerationActions";
import { describeModeration } from "./moderationState";
import styles from "./styles.module.scss";

interface OrderModerationBlockProps {
  orderType: string;
  orderId: number;
  /** After an approve or a cancel, for the page to reload the order. */
  onChanged: () => void;
}

/**
 * The order page's moderation line: where the order stands and, while it is
 * in moderation, the approve and reject buttons. Nothing for an order placed
 * without moderation, or when the backend has none.
 */
const OrderModerationBlock: React.FC<OrderModerationBlockProps> = ({
  orderType,
  orderId,
  onChanged,
}) => {
  const { data, error, refetch } = useQuery(GET_ORDER_MODERATION, {
    variables: { orderType, orderId },
    fetchPolicy: "no-cache",
  });
  const order = data?.getOrderByTypeAndId;
  if (error || !order?.moderation) return null;

  const inModeration = order.status === "MODERATION";
  return (
    <div className={styles.orderBlock}>
      <div className={styles.orderBlockText}>
        <span className={styles.orderBlockTitle}>
          {inModeration ? "In moderation" : "Moderation"}
        </span>
        <span className={styles.state}>
          {describeModeration(order.moderation)}
        </span>
      </div>
      {inModeration && (
        <ModerationActions
          orderType={orderType}
          hashId={order.hashId}
          approved={Boolean(order.moderation.approvedAt)}
          onDone={() => {
            refetch();
            onChanged();
          }}
        />
      )}
    </div>
  );
};

export default OrderModerationBlock;
